var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 623,
    height: 600.495,
    viewBox: "0 0 623 600.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-230.99 -38.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background_1_",
    transform: "translate(230.99 38.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4441",
    "data-name": "Group 4441",
    transform: "translate(384.444 64.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4440",
    "data-name": "Group 4440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M964.277,171.386c3.835-6.882,12.976-2.522,17.493,1,4.623,3.572,8.983,7.355,15.077,7.775,10.664.788,20.12-7.092,29.26-11.294,5.674-2.627,11.715-4.255,17.914-2.732,6.3,1.523,11.767,5.1,17.861,7.2,5.253,1.786,10.611,1.891,15.549-.84,6.672-3.677,11.452-9.613,19.857-8.3,8.037,1.261,14.551,6.777,22.431,8.563,5.674,1.261,12.03.893,16.022-3.782.63-.788-.473-1.891-1.1-1.1-4.518,5.306-12.083,4.465-18.019,2.364-6.776-2.364-12.713-6.882-20.015-7.722-7.092-.788-11.872,3.152-17.336,6.934-2.837,1.944-5.884,3.52-9.4,3.677a23.125,23.125,0,0,1-9.719-2.1c-5.936-2.364-11.557-5.884-17.966-6.829-5.2-.788-10.244.473-15.024,2.522-9.876,4.2-20.54,13.816-31.992,11.715-7.459-1.366-11.715-8.3-18.491-11.032-4.728-1.891-11.032-1.681-13.763,3.2-.473.841.893,1.681,1.366.788Z",
    transform: "translate(-962.814 -162.407)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(462.228 44.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M1112.363,135.328c4.885-10.244,18.491-5.568,26.214-2.364,4.676,1.944,9.561,3.835,14.709,3.625a34.549,34.549,0,0,0,12.135-3.152c8.878-3.835,17.966-10.086,28.1-7.355,8.931,2.469,16.705,9.876,26.529,7.775,5.674-1.208,10.4-4.938,15.917-6.514,7.3-2.049,14.341,1.208,20.8,4.36.893.42,1.734-.893.788-1.366-5.2-2.522-10.664-5.148-16.6-5.253-5.359-.053-9.981,2.522-14.657,4.728-5.568,2.679-10.716,3.677-16.653,1.523-4.885-1.734-9.3-4.675-14.236-6.356-9.666-3.257-18.386,1.156-27,5.306-4.675,2.206-9.561,4.413-14.814,4.675-5.936.315-11.347-2.206-16.705-4.413-8.09-3.31-21.171-6.041-25.951,3.94-.368.946,1,1.786,1.419.841Z",
    transform: "translate(-1110.882 -123.85)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445",
    transform: "translate(0 420.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M232.571,844.331c.578-2.942,3.415-4.413,6.251-4.465,3.257-.052,6.094,2.049,8.458,4.045,3.782,3.257,7.67,7.565,13.081,7.722,4.465.157,7.617-2.994,10.559-5.884,3.572-3.572,7.3-5.989,12.5-5.148,8.458,1.313,15.287,7.617,23.745,8.826a14.6,14.6,0,0,0,11.189-3.1c2.154-1.628,4.045-3.572,6.514-4.675a17.5,17.5,0,0,1,10.244-.893c10.822,1.839,23.8,11.032,34.2,3.1.788-.63,0-2-.788-1.366-10.244,7.775-23.377-1.944-34.094-3.415a18.135,18.135,0,0,0-14.6,4.045c-2.206,1.786-4.36,3.73-7.144,4.57a14.726,14.726,0,0,1-7.092-.053c-8.2-1.944-15.129-8.195-23.745-8.668-4.15-.21-7.617,1.576-10.612,4.308-4.57,4.2-8.668,9.141-15.392,5.568-5.306-2.837-8.773-8.878-14.919-10.244-4.045-.893-9.036,1-9.929,5.411-.105.893,1.418,1.313,1.576.315Z",
    transform: "translate(-230.99 -838.389)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4447",
    "data-name": "Group 4447",
    transform: "translate(86.758 404.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M397.749,814.453c1.208-3.73,5.463-4.57,8.93-4.2,4.045.42,7.565,2.837,11.4,4.045a14.209,14.209,0,0,0,10.191-.368c3.467-1.418,7.144-4.308,11.084-3.625,3.52.63,5.726,3.94,9.088,5.043,2.994.946,5.936-.052,8.668-1.471,4.1-2.1,7.565-4.36,12.345-4.255,5.1.105,9.981,2.206,14.552,4.255.946.42,1.734-.946.788-1.366-4.2-1.839-8.458-3.677-13.028-4.255a19.582,19.582,0,0,0-12.24,2.522c-4.518,2.417-8.563,4.886-13.343,1.576-2.889-2-5.306-4.1-9.036-3.677-3.94.42-7.144,3.1-10.822,4.308-5.2,1.681-9.876-1-14.6-2.942-5.148-2.049-13.448-2.574-15.55,3.992-.263.946,1.261,1.366,1.576.42Z",
    transform: "translate(-396.142 -808.092)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4449",
    "data-name": "Group 4449",
    transform: "translate(80.631 48.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4448",
    "data-name": "Group 4448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M384.49,138.667a8.022,8.022,0,0,0,7.985,6.409c3.992-.053,6.672-3.415,6.777-7.2.105-3.73-2.311-7.144-6.146-7.512a8.016,8.016,0,0,0-8.563,5.936c-.21,1,1.313,1.418,1.523.42a6.418,6.418,0,0,1,6.251-4.78c3.31,0,5.463,2.837,5.358,5.989-.263,7.3-10.506,7.144-11.662.42-.158-1.1-1.681-.683-1.523.315Z",
    transform: "translate(-384.478 -130.331)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 4.728,
    cy: 4.728,
    r: 4.728,
    transform: "translate(75.179 293.915)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 16.075,
    cy: 16.075,
    r: 16.075,
    transform: "translate(205.249 516.916)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 8.983,
    cy: 8.983,
    r: 8.983,
    transform: "translate(544.766 168.731)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(168.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M552.733,52.467c5.674-7.144,15.812-1.1,22.746,0,7.355,1.156,12.4-3.2,18.229-6.934,3.625-2.311,7.092-3.467,11.452-2.942,3.73.42,7.46,1.576,11.242.788a35.629,35.629,0,0,0,5.568-2.1,13.757,13.757,0,0,1,7.827-.788c4.675.893,8.878,3.572,12.765,6.2.84.578,1.628-.788.788-1.366-3.887-2.574-8.037-5.253-12.713-6.251-3.993-.893-7.355-.053-11.032,1.523-4.99,2.154-9.193,1-14.341.42a16.825,16.825,0,0,0-10.454,2.049c-3.31,1.839-6.2,4.308-9.561,6.146-4.518,2.416-8.983,2.1-13.816.683-6.3-1.839-14.814-4.728-19.8,1.471-.63.788.473,1.891,1.1,1.1Z",
    transform: "translate(-551.442 -38.706)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4453",
    "data-name": "Group 4453",
    transform: "translate(208.618 17.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    "data-name": "Group 4452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M629.577,85.222c4.465-8.09,14.657-8.931,22.852-7.46,4.518.788,8.931,2.259,13.448,3.1,3.415.63,6.146.263,8.93-1.839,3.415-2.627,6.2-4.78,10.717-4.78,4.15,0,8.2,1.366,11.977,2.889,7.354,2.994,15.339,7.092,23.272,3.835.946-.368.525-1.891-.42-1.523-9.141,3.73-17.966-2.574-26.424-5.306-3.52-1.1-7.3-1.891-10.979-1.313-4.045.63-6.356,2.994-9.508,5.253-4.36,3.1-10.086.578-14.762-.578a52.357,52.357,0,0,0-13.658-2c-6.619.158-13.448,2.889-16.81,8.931-.473.893.893,1.681,1.366.788Z",
    transform: "translate(-628.114 -72.629)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 10.191,
    cy: 10.191,
    r: 10.191,
    transform: "translate(28.635 489.756)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 5.043,
    cy: 5.043,
    r: 5.043,
    transform: "translate(62.519 317.765)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 3.467,
    cy: 3.467,
    r: 3.467,
    transform: "translate(525.802 419.783)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 6.041,
    cy: 6.041,
    r: 6.041,
    transform: "translate(361.008 13.235)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 7.144,
    cy: 7.144,
    r: 7.144,
    transform: "translate(106.383 350.861)",
    fill: "#fd199e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 6.251,
    cy: 6.251,
    r: 6.251,
    transform: "translate(486.403 130.067)",
    fill: "#fd199e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 7.144,
    cy: 7.144,
    r: 7.144,
    transform: "translate(106.383 504.623)",
    fill: "#fd199e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4455",
    "data-name": "Group 4455",
    transform: "translate(419.168 478.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    "data-name": "Group 4454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M1030.325,956.8a7.673,7.673,0,0,1,8.983-3.94c3.047.893,4.308,4.2,7.092,5.516,4.938,2.364,7.932-3.782,11.452-5.936,5.411-3.309,9.613,4.78,15.182,3.52,3.257-.736,4.938-4.2,8.248-5.148a9.85,9.85,0,0,1,5.516.053c2,.63,3.572,2.1,5.463,2.889a5.034,5.034,0,0,0,3.888.368c1.839-.63,2.889-2.417,4.78-3.047,4.413-1.418,9.351,1.576,12.923,3.887.841.578,1.629-.788.788-1.366-2.994-1.944-6.251-3.782-9.823-4.308a9.2,9.2,0,0,0-4.308.263c-1.786.525-2.732,2.049-4.308,2.732-2.784,1.208-4.833-1-7.092-2.154a11.259,11.259,0,0,0-12.87,1.681c-1.681,1.471-3.047,3.047-5.516,2.522a15.188,15.188,0,0,1-4.518-2.259c-2.154-1.261-4.623-2.574-7.2-1.891-2.521.683-4.255,2.784-6.041,4.518-1.051,1.051-2.259,2.259-3.782,2.522-2.259.42-3.73-1.471-5.1-2.942-4.307-4.57-12.083-4.36-15.077,1.734-.473.893.893,1.681,1.313.788Z",
    transform: "translate(-1028.913 -948.828)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(469.572 467.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4456",
    "data-name": "Group 4456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M1126.406,936.1a8.42,8.42,0,0,1,6.146-5.1c3.047-.683,5.516.788,8.195,2.1,1.734.893,3.677,1.786,5.673,1.576,2.259-.263,3.52-2,5.253-3.257a7.825,7.825,0,0,1,8.51-.578c1.471.841,2.626,2.627,4.57,2.154a11.217,11.217,0,0,0,2.206-1.208,7.826,7.826,0,0,1,5.463-.315,24.65,24.65,0,0,1,8.037,4.255c.841.578,1.629-.788.788-1.366-4.1-2.942-9.981-6.567-15.077-3.94-.945.473-1.523,1.313-2.837.84-.578-.21-1.208-1.051-1.734-1.366a8.508,8.508,0,0,0-3.1-1.313,9.472,9.472,0,0,0-6.462.788c-3.047,1.629-4.465,4.78-8.458,3.362-2.784-1-5.148-3.047-8.195-3.362a10.216,10.216,0,0,0-10.454,6.356c-.42.893,1.1,1.313,1.471.368Z",
    transform: "translate(-1124.862 -928.344)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(479.547 359.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M1145.4,730.239a5.982,5.982,0,0,1,9.246-.946c1.313,1.418,2.259,3.677,4.57,3.52,1.523-.105,2.626-1.261,3.782-2.1,1.786-1.313,3.782-2.732,6.094-2.416,2.522.368,4.57,3.152,7.3,2.1,1.419-.525,2.364-1.891,3.625-2.679a12.915,12.915,0,0,1,4.518-1.786,14.36,14.36,0,0,1,10.559,2c2.732,1.681,3.625-.315,6.041-1.576a9.981,9.981,0,0,1,11.137,1.523c.736.683,1.891-.42,1.1-1.1a11.568,11.568,0,0,0-8.51-2.994,10.835,10.835,0,0,0-3.887.946c-2.154.946-3.047,2.574-5.726,1.471-3.257-1.313-5.883-2.417-9.508-2.049a14.939,14.939,0,0,0-7.88,3.2c-1.366,1.051-2.469,2-4.518,1.156-.84-.315-1.523-.945-2.311-1.261a6.534,6.534,0,0,0-3.625-.525,11.654,11.654,0,0,0-4.938,2.364,12.4,12.4,0,0,1-2.364,1.734c-2.259.893-2.731-.578-3.887-1.944a7.549,7.549,0,0,0-12.293.578c-.42.841.946,1.629,1.471.788Z",
    transform: "translate(-1143.849 -723.752)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(529.505 347.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M1240.5,706.811a6.472,6.472,0,0,1,5.779-3.152c2.732.105,3.52,2.1,5.726,3.047a2.643,2.643,0,0,0,2.942-.473c2.259-1.734,3.782-3.2,6.829-3.152a7.769,7.769,0,0,1,3.73,1,10.974,10.974,0,0,0,2.259,1.313c1.523.368,2.522-.578,3.625-1.471a11.167,11.167,0,0,1,14.551.683c.736.683,1.839-.42,1.1-1.1a12.954,12.954,0,0,0-12.4-3.047,12.633,12.633,0,0,0-3.1,1.366c-1.314.84-2.364,2.364-4.15,1.681-1.051-.42-1.891-1.208-2.994-1.576a9.4,9.4,0,0,0-3.415-.42,9.772,9.772,0,0,0-5.568,2.049c-.42.315-.788.893-1.261,1.156-1.839,1.156-2.049.21-3.2-.735a7.752,7.752,0,0,0-1.891-1.208,8,8,0,0,0-10.034,3.31c-.42.788.945,1.629,1.471.735Z",
    transform: "translate(-1238.95 -699.962)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "translate(234.082 88.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463",
    transform: "translate(0 445.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M372.054,982.2H237.624a.789.789,0,0,0,0,1.576h134.43a.789.789,0,0,0,0-1.576Z",
    transform: "translate(-236.875 -982.2)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4465",
    "data-name": "Group 4465",
    transform: "translate(294.969 436.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M799.124,965.776H943.115a.789.789,0,0,0,0-1.576H799.124a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-798.375 -964.2)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467",
    transform: "translate(447.629 436.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M1089.724,965.776h86.206a.789.789,0,0,0,0-1.576h-86.206a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1088.975 -964.2)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469",
    transform: "translate(546.475 436.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M1277.906,965.776h15.024a.789.789,0,0,0,0-1.576h-15.024a.788.788,0,0,0,0,1.576Z",
    transform: "translate(-1277.137 -964.2)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(474.906 382.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M1142.476,915.229V862.224a.789.789,0,0,0-1.576,0v53.005a.789.789,0,0,0,1.576,0Z",
    transform: "translate(-1140.9 -861.475)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473",
    transform: "translate(475.261 382.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M1142.324,862.976h95.084a.789.789,0,0,0,0-1.576h-95.084a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1141.575 -861.4)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(570.62 383.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M1323.1,864.688v50.431a.789.789,0,0,0,1.576,0V864.688a.788.788,0,0,0-1.576,0Z",
    transform: "translate(-1323.1 -863.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(484.835 388.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M1159.8,873.824V911.7a.789.789,0,0,0,1.576,0V873.824a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-1159.8 -873.075)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(497.075 388.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M1183.1,874.424V908.78a.789.789,0,0,0,1.576,0V874.424a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-1183.1 -873.675)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(510.576 387.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M1208.8,872.624v34.041a.789.789,0,0,0,1.576,0V872.624a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-1208.8 -871.875)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(524.392 389.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M1235.1,876.906v34.671a.789.789,0,0,0,1.576,0V876.906a.788.788,0,0,0-1.576,0Z",
    transform: "translate(-1235.1 -876.137)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(537.84 390.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M1260.7,878.124v35.67a.789.789,0,0,0,1.576,0v-35.67a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-1260.7 -877.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    transform: "translate(554.545 390.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M1292.5,878.724V912.45a.789.789,0,0,0,1.576,0V878.724a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-1292.5 -877.975)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(565.787 392.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M1313.9,881.788v30.206a.789.789,0,0,0,1.576,0V881.788a.788.788,0,0,0-1.576,0Z",
    transform: "translate(-1313.9 -881)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    transform: "translate(4.478 322.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M245.4,748.724v41.4a.789.789,0,0,0,1.576,0v-41.4a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-245.4 -747.975)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(6.212 322.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M249.488,749.476h80.48a.789.789,0,0,0,0-1.576h-80.48a.788.788,0,1,0,0,1.576Z",
    transform: "translate(-248.7 -747.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    transform: "translate(6.212 364.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M249.488,829.376h76.54a.789.789,0,0,0,0-1.576h-76.54a.788.788,0,0,0,0,1.576Z",
    transform: "translate(-248.7 -827.8)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(86.114 323.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M400.8,750.924V788.9a.789.789,0,0,0,1.576,0V750.924a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-400.8 -750.175)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(41.934 301.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M316.7,707.724v13.028a.789.789,0,0,0,1.576,0V707.724a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-316.7 -706.975)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(42.499 301.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M318.524,708.476h52.165a.789.789,0,0,0,0-1.576H318.524a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-317.775 -706.9)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(43.077 314.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M319.624,734.376h50.431a.789.789,0,0,0,0-1.576H319.624a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-318.875 -732.8)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(94.046 303.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M415.9,712.024v10.769a.789.789,0,0,0,1.576,0V712.024a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-415.9 -711.275)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507",
    transform: "translate(129.639 51.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M484.2,232.631a80.351,80.351,0,0,0,10.559,2.259c1,.105,1.1-1.471.105-1.576a74.028,74.028,0,0,1-10.139-2.154.781.781,0,1,0-.525,1.471Z",
    transform: "translate(-483.654 -231.116)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(140.053 12.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M526.131,189.175a37.741,37.741,0,0,0-1.839-19.017c-1.944-5.253-7.144-14.289-13.291-10.4-5.2,3.31-5.2,11.925-5.621,17.808a149.156,149.156,0,0,0,.053,21.118.793.793,0,1,1-1.576.158,159.107,159.107,0,0,1,.368-26.476c.63-5.831,2.049-13.869,8.3-15.077,5.568-1.051,9.771,4.78,12.03,9.613A39.6,39.6,0,0,1,527.6,189.6c-.053,1.051-1.628.735-1.471-.42Z",
    transform: "translate(-503.478 -157.164)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(129.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M526.351,177.264a47.212,47.212,0,0,0-5.2-27.947c-4.045-7.355-11.347-14.289-19.542-13.764-9.036.578-14.289,9.981-16.075,18.859-2,9.929-1.786,20.7-.84,30.837a.793.793,0,1,1-1.576.158,122.4,122.4,0,0,1,.368-28.42c1.051-7.3,3.625-14.6,8.931-19.227,11.242-9.876,25.163.63,30.942,12.555a49.914,49.914,0,0,1,4.518,27.369c-.105,1.051-1.681.683-1.523-.42Z",
    transform: "translate(-482.471 -133.841)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    transform: "translate(162.667 43.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M546.775,218.549a8.041,8.041,0,0,0,12.082-1.734c.525-.841-.893-1.576-1.418-.683a6.333,6.333,0,0,1-9.561,1.208.82.82,0,0,0-1.1,1.208Z",
    transform: "translate(-546.526 -215.725)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(129.821 57.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M484,244.724V284.7a.789.789,0,0,0,1.576,0V244.724a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-484 -243.975)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517",
    transform: "translate(130.21 46.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M485.718,235.932A332.321,332.321,0,0,0,532,224.585c.946-.315.525-1.839-.42-1.523A318.135,318.135,0,0,1,485.3,234.409c-1,.158-.525,1.681.42,1.523Z",
    transform: "translate(-484.742 -223.019)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(177.783 48.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M575.3,227.124v37.456a.789.789,0,0,0,1.576,0V227.124a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-575.3 -226.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(130.616 87.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M486.5,313.422a295.176,295.176,0,0,0,46.018-11.137c.946-.315.525-1.839-.42-1.523A295.165,295.165,0,0,1,486.084,311.9c-1,.158-.578,1.681.42,1.523Z",
    transform: "translate(-485.514 -300.719)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(151.273 62.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M527.654,263.335a14.2,14.2,0,0,1-1.208-4.36c-.052-1.786,1.156-4.15,3.257-3.625,3.2.788,2.311,5.936,1.156,7.932a.789.789,0,0,0,1.366.788c1.734-2.942,2.206-9.666-2.417-10.4A4.516,4.516,0,0,0,525.4,256.3c-1.208,2.416-.21,5.2.683,7.512.42.893,1.944.473,1.576-.473Z",
    transform: "translate(-524.837 -253.634)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(152.829 70.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M527.8,269.984c.21,3.782.42,7.617.63,11.4.105,1.681.946,2.627,2.837,2.206a3.927,3.927,0,0,0,2.889-3.625,24.536,24.536,0,0,0-.42-5.2,38.67,38.67,0,0,1,0-6.041c.053-1-1.523-1-1.576,0a46.379,46.379,0,0,0,0,6.041c.105,1.366,1.418,6.672-.735,7.092-2.206.42-1.628-4.308-1.734-5.621-.1-2.049-.21-4.15-.368-6.2,0-1.051-1.576-1.051-1.523-.053Z",
    transform: "translate(-527.798 -267.975)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(269.557 42.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M750,215.224v33.883a.789.789,0,0,0,1.576,0V215.224a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-750 -214.475)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4529",
    "data-name": "Group 4529",
    transform: "translate(237.446 78.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M689.624,285.376H748.67a.789.789,0,0,0,0-1.576H689.624a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-688.875 -283.8)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4531",
    "data-name": "Group 4531",
    transform: "translate(289.519 81.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M788,289.624v26.9a.789.789,0,0,0,1.576,0v-26.9a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-788 -288.875)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4533",
    "data-name": "Group 4533",
    transform: "translate(7.302 195.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M251.524,506.976h57.313a.789.789,0,0,0,0-1.576H251.524a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-250.775 -505.4)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4535",
    "data-name": "Group 4535",
    transform: "translate(38.572 178.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4534",
    "data-name": "Group 4534",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M311.876,489.585V474.824a.789.789,0,0,0-1.576,0v14.762a.789.789,0,0,0,1.576,0Z",
    transform: "translate(-310.3 -474.075)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4537",
    "data-name": "Group 4537",
    transform: "translate(57.641 197.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4536",
    "data-name": "Group 4536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M346.6,511.124v17.388a.789.789,0,0,0,1.576,0V511.124a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-346.6 -510.375)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    transform: "translate(464.124 295.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4538",
    "data-name": "Group 4538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M1121.124,698.676h71.234a.789.789,0,0,0,0-1.576h-71.234a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1120.375 -697.1)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(507.529 279.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M1204.576,682.178V666.524a.789.789,0,0,0-1.576,0v15.655a.789.789,0,0,0,1.576,0Z",
    transform: "translate(-1203 -665.775)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    transform: "translate(498.848 279.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M1187.224,667.276H1242.8a.789.789,0,0,0,0-1.576h-55.579a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1186.475 -665.7)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(49.341 501.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M331.588,1090.276H435.077a.789.789,0,0,0,0-1.576H331.588a.788.788,0,1,0,0,1.576Z",
    transform: "translate(-330.8 -1088.7)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547",
    transform: "translate(93.56 493.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M415.724,1074.176H528.616a.789.789,0,0,0,0-1.576H415.724a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-414.975 -1072.6)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(167.854 520.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M557.188,1126.076h69.605a.789.789,0,0,0,0-1.576H557.188a.788.788,0,1,0,0,1.576Z",
    transform: "translate(-556.4 -1124.5)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551",
    transform: "translate(258.157 490.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M729.088,1068.776h43.287a.789.789,0,0,0,0-1.576H729.088a.788.788,0,0,0,0,1.576Z",
    transform: "translate(-728.3 -1067.2)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(376.671 474.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M954.688,1038.376h93.14a.789.789,0,0,0,0-1.576h-93.14a.788.788,0,0,0,0,1.576Z",
    transform: "translate(-953.9 -1036.8)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555",
    transform: "translate(442.533 452.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M1080.024,997.176h111a.789.789,0,0,0,0-1.576h-111a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1079.275 -995.6)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(507.411 473.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M1203.524,1036.576h111a.789.789,0,0,0,0-1.576h-111a.789.789,0,0,0,0,1.576Z",
    transform: "translate(-1202.775 -1035)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(464.137 507.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M1121.188,1100.976h49.853a.789.789,0,0,0,0-1.576h-49.853a.788.788,0,0,0,0,1.576Z",
    transform: "translate(-1120.4 -1099.4)",
    fill: "#e8e8e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "machine",
    transform: "translate(264.931 265.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M480.987,1021.887q-39.557,30.889-79.061,61.778Q348.737,1060.5,295.6,1037.332l112.682-61.778a60.536,60.536,0,0,1,15.445,0C458.135,980.176,477.257,1014.8,480.987,1021.887Z",
    transform: "translate(-295.6 -709.814)",
    fill: "#353535",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M496.176,501.284q-.788,119.222-1.576,238.392l77.538,48.855q41.133-28.919,82.318-57.891-.236-100.311-.525-200.674-34.277-29.707-68.5-59.467Q540.75,485.866,496.176,501.284Z",
    transform: "translate(-390.061 -470.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(181.552 97.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M641.2,656.606V876.769a.789.789,0,0,0,1.576,0V656.606a.788.788,0,0,0-1.576,0Z",
    transform: "translate(-641.2 -655.837)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(263.186 59.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M796.6,584.024q.158,78.4.263,156.862c0,14.656.053,29.261.053,43.917a.789.789,0,0,0,1.576,0q-.158-78.4-.263-156.862c0-14.657-.052-29.261-.052-43.917-.053-1-1.628-1-1.576,0Z",
    transform: "translate(-796.598 -583.275)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565",
    transform: "translate(104.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M495.872,501.429Q529.912,490,564.006,478.578c5.621-1.891,11.189-3.73,16.81-5.621,1.208-.42,2.679-1.261,3.992-.841,1,.315,2.364,2,3.2,2.732,2.364,2.049,4.78,4.045,7.144,6.094,9.036,7.67,18.019,15.339,27.054,23.009,10.349,8.825,20.7,17.6,31.047,26.424l.158-1.261q-39.872,20.015-80.48,38.4a5.8,5.8,0,0,0,.946.1c-8.72-7.565-17.441-15.182-26.161-22.747q-20.96-18.2-41.921-36.457c-3.2-2.784-6.356-5.568-9.561-8.353a.816.816,0,0,0-1.366.578v237.6c0,1.051-.21,1.944.525,2.679a13.84,13.84,0,0,0,2.522,1.628c1.786,1.156,3.572,2.259,5.306,3.415q33.568,21.354,67.084,42.656c.578.368,1.156.736,1.681,1.1a.716.716,0,0,0,.788,0q40.9-29.077,81.74-58.1c.841-.578.053-1.944-.788-1.366l-43.024,30.574q-10.874,7.722-21.7,15.445c-3.572,2.522-7.092,5.043-10.664,7.565-1.523,1.1-3.887,2.206-5.1,3.625-.368.42-.315.84-.63.84-.735,0-2.364-1.523-2.942-1.891-2.1-1.366-4.2-2.679-6.356-4.045l-19.069-12.135Q524,757.314,503.7,744.444c-1.891-1.208-3.73-2.364-5.621-3.572a9.171,9.171,0,0,0-1.523-.946c-.368-.158-.683-.683-.368,0,.368.788.158-.368.21-.683.053-.946,0-1.891,0-2.837V508.889a54.843,54.843,0,0,0,0-7.2,5.688,5.688,0,0,1,0-.946c-.473.21-.893.368-1.366.578,8.72,7.565,17.441,15.182,26.161,22.747q20.961,18.2,41.921,36.457c3.2,2.784,6.357,5.568,9.561,8.353a.8.8,0,0,0,.946.1q40.581-18.439,80.48-38.4a.826.826,0,0,0,.158-1.261l-56.1-47.752c-2.259-1.944-4.518-3.835-6.777-5.779-1.051-.893-2.1-1.786-3.2-2.732-.84-.683-2.311-2.469-3.362-2.837-.735-.263-1.366.158-2.1.42-1.471.473-2.942,1-4.465,1.471-2.942,1-5.936,2-8.878,2.994-11.5,3.835-23.062,7.722-34.566,11.557-13.186,4.413-26.319,8.825-39.5,13.238a.82.82,0,0,0,.578,1.523Z",
    transform: "translate(-494.844 -470.142)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(114.993 243.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M516.076,965.918V934.924a.789.789,0,0,0-1.576,0v30.994a.789.789,0,0,0,1.576,0Z",
    transform: "translate(-514.5 -934.175)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(115.021 242.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M514.945,932.877Q533.384,943.2,551.3,954.468c.841.525,1.628-.841.788-1.366q-17.887-11.268-36.352-21.591c-.893-.473-1.681.893-.788,1.366Z",
    transform: "translate(-514.552 -931.414)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571",
    transform: "translate(149.453 264.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M582.148,973.924c-.683,10.769-1.366,21.591-2.049,32.36-.053,1,1.524,1,1.576,0,.683-10.769,1.366-21.591,2.049-32.36.052-1-1.524-1-1.576,0Z",
    transform: "translate(-580.098 -973.175)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(120.089 254.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M525.723,955.306a201.682,201.682,0,0,0-1.523,21.748.789.789,0,0,0,1.576,0,199.884,199.884,0,0,1,1.523-21.748c.158-1.051-1.418-1-1.576,0Z",
    transform: "translate(-524.2 -954.537)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575",
    transform: "translate(127.968 258.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M541.2,962.424c-.946,7.512-1.629,15.024-2,22.536-.052,1,1.523,1,1.576,0,.42-7.512,1.051-15.077,2-22.536.158-1-1.418-1-1.576,0Z",
    transform: "translate(-539.198 -961.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(136.11 263.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M557.168,973.185c-1.156,7.617-2,15.287-2.469,22.957-.052,1,1.523,1,1.576,0,.473-7.565,1.261-15.077,2.417-22.536.158-1-1.366-1.418-1.523-.42Z",
    transform: "translate(-554.698 -972.614)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4579",
    "data-name": "Group 4579",
    transform: "translate(143.622 267.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M570.365,980.024c-.473,6.777-.946,13.5-1.366,20.278-.052,1,1.523,1,1.576,0,.473-6.777.946-13.5,1.366-20.278.052-1-1.523-1-1.576,0Z",
    transform: "translate(-568.998 -979.275)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    transform: "translate(116.048 237.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4580",
    "data-name": "Group 4580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M516.924,922.777q20.094,10.48,39.5,22.221a.788.788,0,0,0,.788-1.366c-12.923-7.827-26.109-15.287-39.5-22.221-.893-.473-1.734.893-.788,1.366Z",
    transform: "translate(-516.508 -921.314)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4583",
    "data-name": "Group 4583",
    transform: "translate(115.834 228.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4582",
    "data-name": "Group 4582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M517.676,913.766v-8.143a.789.789,0,0,0-1.576,0v8.143a.788.788,0,1,0,1.576,0Z",
    transform: "translate(-516.1 -904.875)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4585",
    "data-name": "Group 4585",
    transform: "translate(116.124 227.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4584",
    "data-name": "Group 4584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M517.045,904.592A349.423,349.423,0,0,1,557.6,927.5c.841.578,1.628-.788.788-1.366a341.884,341.884,0,0,0-40.555-22.9c-.893-.42-1.681.893-.788,1.366Z",
    transform: "translate(-516.652 -903.145)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4587",
    "data-name": "Group 4587",
    transform: "translate(155.438 251.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4586",
    "data-name": "Group 4586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M592.284,949.724c-.263,2.364-.525,4.781-.788,7.145-.105,1,1.471,1,1.576,0,.263-2.364.525-4.781.788-7.145.1-1-1.471-1-1.576,0Z",
    transform: "translate(-591.491 -948.975)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4589",
    "data-name": "Group 4589",
    transform: "translate(186.378 73.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4588",
    "data-name": "Group 4588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M651.6,640.821c20.435-8.983,40.45-18.964,59.887-29.944.893-.473.105-1.839-.788-1.366q-29.234,16.39-59.887,29.943c-.946.42-.158,1.786.788,1.366Z",
    transform: "translate(-650.388 -609.414)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4591",
    "data-name": "Group 4591",
    transform: "translate(186.332 103.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4590",
    "data-name": "Group 4590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M650.3,667.024V680.1a.789.789,0,0,0,1.576,0V667.024a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-650.3 -666.275)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4593",
    "data-name": "Group 4593",
    transform: "translate(186.623 94.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M652.033,672.385q21.354-9.456,41.763-20.908c.893-.473.105-1.839-.788-1.366q-20.409,11.426-41.763,20.908c-.893.42-.1,1.786.788,1.366Z",
    transform: "translate(-650.852 -650.013)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    transform: "translate(187.173 174.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M651.9,802.924V917.287a.789.789,0,0,0,1.576,0V802.924a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-651.9 -802.175)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597",
    transform: "translate(191.586 236.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M660.3,921.124v62.093a.789.789,0,0,0,1.576,0V921.124a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-660.3 -920.375)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4599",
    "data-name": "Group 4599",
    transform: "translate(107.902 42.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M501,551.124v80.427a.789.789,0,0,0,1.576,0V551.124a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-501 -550.375)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4601",
    "data-name": "Group 4601",
    transform: "translate(112.419 100.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4600",
    "data-name": "Group 4600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M509.6,661.824v93.035a.789.789,0,0,0,1.576,0V661.824a.789.789,0,0,0-1.576,0Z",
    transform: "translate(-509.6 -661.075)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M495.2,529V768.075q38.769,24.428,77.485,48.855V595.454Q533.917,562.279,495.2,529Z",
    transform: "translate(-390.345 -498.08)",
    fill: "#353535",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M498.213,582.7c7.827,37.928,15.5,69.448,21.591,92.877,9.456,36.458,14.289,50.641,20.7,65.14a302.34,302.34,0,0,0,32.57,56.367q.473-54.844.893-109.635c2.574,51.114,25.688,83.211,44.022,82.791,14.814-.368,29.313-21.854,37.4-48.015V784.74q-40.739,28.368-81.425,56.788-38.533-24.191-77.065-48.435Q497.531,687.9,498.213,582.7Z",
    transform: "translate(-391.152 -523.57)",
    fill: "#353535",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "holograme",
    transform: "translate(423.783 249.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M714.492,490.163q-36.4,20.567-72.757,41.133-21.591-29.234-43.234-58.521,41.606-16.311,83.264-32.675Q698.154,465.158,714.492,490.163Z",
    transform: "translate(-598.231 -440.1)",
    fill: "#fd199e",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4603",
    "data-name": "Group 4603",
    transform: "translate(3.576 16.177)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4602",
    "data-name": "Group 4602",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "x",
    transform: "matrix(0.896, -0.444, 0.444, 0.896, 11.09, 28.879)",
    fill: "#fd199e",
    fontSize: 26,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(30.206 22.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4604",
    "data-name": "Group 4604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M656.23,486.194a7.9,7.9,0,0,1,3.625-3.047c.473-.21.053-.893-.42-.683a8.967,8.967,0,0,0-3.887,3.362c-.263.42.42.788.683.368Z",
    transform: "translate(-655.488 -482.425)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4607",
    "data-name": "Group 4607",
    transform: "translate(30.243 22.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4606",
    "data-name": "Group 4606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M656.316,489.774a8.8,8.8,0,0,1,7.407-5.989c.525-.053.525-.84,0-.788a9.425,9.425,0,0,0-8.143,6.566c-.158.473.578.683.736.21Z",
    transform: "translate(-655.558 -482.995)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4609",
    "data-name": "Group 4609",
    transform: "translate(31.136 24.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4608",
    "data-name": "Group 4608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M658.016,494.174c1.156-4.623,4.413-7.985,9.4-6.356.473.158.683-.578.21-.735-5.358-1.786-9.088,1.839-10.349,6.882-.158.473.578.683.735.21Z",
    transform: "translate(-657.258 -486.621)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    transform: "translate(32.732 25.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4610",
    "data-name": "Group 4610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M661.033,498.157c.158-2.574.578-5.621,3.047-7.092,2.417-1.418,5.148-.42,6.934,1.471.368.368.893-.21.578-.578-1.891-2-4.676-3.047-7.3-1.891-3.152,1.366-3.782,4.938-3.992,8.037a.369.369,0,1,0,.735.053Z",
    transform: "translate(-660.295 -489.587)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    transform: "translate(34.468 27.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M664.966,502.353c.525-2.994-1.944-5.726.736-8.3,1.944-1.839,4.413-.893,5.989.788a10.19,10.19,0,0,1,2.259,5.674c.052.473.84.525.788,0-.42-3.467-2.627-8.931-7.144-8.353a5.1,5.1,0,0,0-3.677,3.1c-1,2.364.735,4.465.315,6.829-.105.525.683.735.735.263Z",
    transform: "translate(-663.601 -492.119)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(36.102 28.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M668.176,504.974c1.628-2.679-1.786-5.253-.42-7.722,1.418-2.679,4.2-.893,5.148,1a9.728,9.728,0,0,1,.42,6.672c-.1.473.63.683.735.21.788-3.047.473-9.824-3.94-10.034a3.414,3.414,0,0,0-3.257,2.259c-.84,2.522,2.154,4.833.683,7.2a.38.38,0,1,0,.63.42Z",
    transform: "translate(-666.711 -495.096)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    transform: "translate(37.616 30.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M671.383,507.213a6.294,6.294,0,0,0-.368-5.726,6.535,6.535,0,0,1-.525-1.051c1.156-.788,1.839-.578,2.049.525a5.721,5.721,0,0,1,.42,1.628,9.086,9.086,0,0,1-.578,4.728c-.21.473.578.683.735.21a9.166,9.166,0,0,0,.473-5.673c-.263-1.208-.946-3.2-2.469-3.257a1.456,1.456,0,0,0-1.524,1.681,7.523,7.523,0,0,0,1,2.311,5.51,5.51,0,0,1-.053,4.465c-.105.42.63.63.84.158Z",
    transform: "translate(-669.594 -498.595)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619",
    transform: "translate(49.899 22.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M718.046,528.556c.157-.946.21-2-.683-2.574s-2.416,0-3.467-.053a20.069,20.069,0,0,1-4.938-1.261c-3.2-1.051-6.461-2.522-8.773-5.148-1.051-1.208-2.417-3.152-2.521-4.833-.21-3.94,2.049-.893,3.624-.473.841.21,1.524.158,1.576-.788.053-.63-.473-.945-.893-1.418-1.1-1.156-2.154-2.259-3.152-3.52a27.592,27.592,0,0,1-4.518-8.72c-.368-1.208-1.576-5.936.788-5.621,1.1.105,2.994,2.679,3.677,3.52l.578-.578c-1.524-1.944-4.045-4.833-3.888-7.46.263-5.043,6.094-.21,7.144,1.629l.63-.473a6.606,6.606,0,0,1-1.734-3.467c-.1-3.2,1.681-2,2.942-1.156a18.933,18.933,0,0,1,4.1,4.57.4.4,0,0,0,.683-.42,10.082,10.082,0,0,1-.841-2.206c-.473-1-.053-1.523,1.366-1.629,1.944-1,1.786-.735,3.047.63a38.721,38.721,0,0,1,3.677,5.043c1.891,2.942,4.045,5.568,6.146,8.3a16.553,16.553,0,0,1,3.047,5.884,55.263,55.263,0,0,1,.841,6.514c.368,2.522,1.418,4.781,3.835,5.936.473.21.84-.473.42-.683-4.938-2.364-3.2-10.086-5.2-14.5a23.436,23.436,0,0,0-3.677-5.411,71.229,71.229,0,0,1-4.938-6.882c-1.524-2.364-4.2-7.407-7.46-7.512-3.625-.105-1.733,4.991-.946,6.724.21-.158.473-.263.683-.42-1.313-1.839-4.728-6.987-7.722-5.989-2.627.893.21,5.831,1.208,6.987.315.368.84-.105.63-.473a9,9,0,0,0-3.94-3.73c-1.051-.473-3.257-1.313-4.255-.263s-.473,3.362-.053,4.57a19.882,19.882,0,0,0,3.782,6.2c.315.42.84-.158.578-.578-.841-1.051-3.625-4.728-5.358-4.15-1.471.525-1.1,3.677-1,4.675a23.717,23.717,0,0,0,3.677,9.088,29.8,29.8,0,0,0,2.627,3.572c.473.578,1.471,1.208,1.786,1.891,1,.683.788.893-.683.63-.42-.263-.893-.473-1.313-.736-1.313-.683-2.154-.683-2.416,1-.315,2.259,1.261,4.991,2.627,6.619a17.587,17.587,0,0,0,7.25,4.885,43.343,43.343,0,0,0,5.043,1.628c1.261.315,5.884.105,5.621,2.049-.1.893.683,1.1.736.578Z",
    transform: "translate(-692.975 -483.797)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621",
    transform: "translate(54.963 35.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M702.712,507.866c2.206,2.679,3.992,5.726,5.936,8.615.263.42.946,0,.683-.42-2-2.942-3.835-6.041-6.094-8.773-.315-.368-.84.158-.525.578Z",
    transform: "translate(-702.615 -507.164)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4623",
    "data-name": "Group 4623",
    transform: "translate(58.258 28.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M708.947,494.284c2.154,2.942,4.15,5.936,6.041,9.036a.4.4,0,0,0,.683-.42c-1.891-3.1-3.887-6.094-6.041-9.036-.263-.368-.946,0-.683.42Z",
    transform: "translate(-708.888 -493.713)",
    fill: "#fd199e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625",
    transform: "translate(0 32.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M598.047,501.984q21.2,29.392,43.392,58.048c.315.42.84-.158.578-.578q-22.142-28.6-43.287-57.891c-.263-.368-.946,0-.683.42Z",
    transform: "translate(-597.988 -501.413)",
    fill: "#fd199e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "guy",
    transform: "translate(484.074 115.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leg_back",
    transform: "translate(114.503 224.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M956.873,1012.683c.841,9.929,1.681,19.8,2.522,29.733q-29.707,13.16-28.63,16.81,1.34,4.413,47.384-5.043c-.63-16.81-1.313-33.673-1.944-50.484C969.8,1006.695,963.335,1009.689,956.873,1012.683Z",
    transform: "translate(-930.725 -798.404)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M979.8,614.214c2.994,2,3.52,6.461,4.57,15.339.525,4.255.788,9.508-.525,24.743-.158,1.629-.578,6.829-1.891,18.019-1.891,16.39-2.416,18.334-2.942,25.268-.42,5.411-.683,11.137-.525,23.43.158,11.715.315,27.737,2.154,50.063,1.366,16.548,3.677,37.14,7.827,60.78a54.078,54.078,0,0,1-11.032,4.308,62.351,62.351,0,0,1-17.231,1.891,91.8,91.8,0,0,1-11.82-.788c-1.523-7.932-3.52-19.857-5.1-34.461-.841-7.565-1.366-15.917-2.416-32.308-1.471-22.957-2.207-34.409-2.417-44.127-.1-4.308-.1-7.88.525-37.4.946-44.285,1.313-49.7,5.936-56.788C954.108,618,972.757,609.486,979.8,614.214Z",
    transform: "translate(-934.369 -612.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627",
    transform: "translate(43.182 1.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M1019.111,617.482a264.832,264.832,0,0,1-.788,42.814c-1.418,13.869-3.782,27.58-4.676,41.448-1.838,28.473.053,57.1,3.2,85.418,1.786,15.812,3.94,31.625,6.146,47.384.158,1,1.681.578,1.524-.42-3.94-28.42-7.88-56.893-9.4-85.575a418.463,418.463,0,0,1-.21-42.183c.735-13.974,2.784-27.685,4.465-41.553a259.607,259.607,0,0,0,1.313-47.384.789.789,0,0,0-1.576.053Z",
    transform: "translate(-1012.925 -616.687)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629",
    transform: "translate(3.395 70.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M937.615,747.788A834.728,834.728,0,0,0,942.343,867.4q1.812,16.548,4.36,32.99c.158,1,1.681.578,1.523-.42a837.775,837.775,0,0,1-9.4-118.618q-.158-16.784.42-33.568a.815.815,0,0,0-1.628,0Z",
    transform: "translate(-937.189 -747)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(12.812 218.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M955.684,1035.242a63.663,63.663,0,0,0,40.345-5.148c.893-.42.105-1.786-.788-1.366a61.717,61.717,0,0,1-39.136,4.99c-1-.21-1.418,1.313-.42,1.523Z",
    transform: "translate(-955.114 -1028.649)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M943.778,674.5c-1.418,9.929-2.732,21.223-3.625,33.726-.525,6.829-1.261,18.544-1.366,33.253-.105,12.24.368,22.589,1.366,42.866,1.1,22.9,1.681,34.619,3.2,47.384,1.734,14.709,3.888,26.687,5.463,34.619a50.882,50.882,0,0,0,14.6.893,52.1,52.1,0,0,0,10.034-1.839q-6.7-25.058-12.293-52.427A898.529,898.529,0,0,1,943.778,674.5Z",
    transform: "translate(-934.545 -642.14)",
    fill: "#353535",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M939.989,772.6c2.259,18.807,4.255,34.987,5.936,47.857,4.308,33.673,5.673,42.131,8.668,52.848a200.024,200.024,0,0,0,15.97,40.082,34.5,34.5,0,0,1-14.6.473,33.422,33.422,0,0,1-7.3-2.259c-2.154-12.765-3.992-26.161-5.463-40.082A673.345,673.345,0,0,1,939.989,772.6Z",
    transform: "translate(-934.854 -688.706)",
    fill: "#353535",
    opacity: 0.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg_front",
    transform: "translate(42.197 221.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M831.809,1031.5c-.735,10.454-1.471,20.96-2.259,31.414q-37.035,9.141-36.458,13.186.63,4.807,54.686,2.259c1.1-15.129,2.259-30.311,3.362-45.44C844.68,1032.393,838.218,1031.92,831.809,1031.5Z",
    transform: "translate(-793.085 -808.597)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M878.633,614.259a35,35,0,0,0-5.148,7.512,25.846,25.846,0,0,0-2.364,6.567c-.578,3.94-1.419,9.4-2.364,15.917-2.049,14.236-3.467,25.373-4.2,31.362-2.626,20.75-4.1,34.2-7.039,59.047-4.36,36.72-5.621,44.652-8.878,74.491-1.208,11.084-2.206,20.225-2.837,26.214a19.208,19.208,0,0,0,4.833,5.2,28.856,28.856,0,0,0,4.99,2.784c3.047,1.418,6.146,2.679,7.512,3.152,8.143,2.627,22.852-1.313,23.639-1.523,0-5.726.105-13.448.526-22.642.158-3.677.683-13.606,2.732-32.675,1.839-17.073,3.257-30.574,6.461-48.75,2.312-13.291,4.57-23.43,6.619-32.255,3.1-13.869,6.146-25.688,8.668-34.882L922.655,652.5c1.051-1.523,10.664-15.76,5.2-28.683C919.661,604.173,885.409,607.01,878.633,614.259Z",
    transform: "translate(-818.107 -607.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4633",
    "data-name": "Group 4633",
    transform: "translate(26.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M876.083,607.718c-9.823,27-11.925,56.157-15.234,84.472q-5.358,45.546-10.664,91.144-2.994,25.531-5.989,51.009c-.1,1,1.471,1,1.576,0q5.28-45.309,10.612-90.618c3.467-29.681,6.514-59.414,10.559-88.99,2.154-15.812,5.148-31.572,10.664-46.6.315-.946-1.208-1.366-1.524-.42Z",
    transform: "translate(-844.19 -607.185)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(84.648 43.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4634",
    "data-name": "Group 4634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M973.751,690.654a176.361,176.361,0,0,0-19.489,41.973c-.315.945,1.208,1.366,1.523.42a174.27,174.27,0,0,1,19.332-41.606c.525-.84-.841-1.681-1.366-.788Z",
    transform: "translate(-954.219 -690.272)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4637",
    "data-name": "Group 4637",
    transform: "translate(68.038 62.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M948.341,726.821a652.141,652.141,0,0,0-24.112,134.746q-1.419,19.621-1.629,39.242a.789.789,0,0,0,1.576,0A650.9,650.9,0,0,1,940.146,764.8q4.255-18.912,9.718-37.508a.8.8,0,0,0-1.523-.473Z",
    transform: "translate(-922.6 -726.291)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4639",
    "data-name": "Group 4639",
    transform: "translate(26.795 226.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4638",
    "data-name": "Group 4638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M844.306,1039.937a35.676,35.676,0,0,0,42.026,9.4c.946-.42.1-1.786-.788-1.366a34.2,34.2,0,0,1-40.135-9.193c-.683-.735-1.786.368-1.1,1.156Z",
    transform: "translate(-844.091 -1038.54)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M889.187,627.7c6.251,5.726-3.625,24.585-9.561,39.189-8.668,21.328-10.507,56.577-14.131,127.181-.788,14.919-1.629,35.827-1.839,61.1a23.311,23.311,0,0,1-6.356-1.839,27.283,27.283,0,0,1-11.4-9.561c1.471-10.454,3.572-26.266,5.936-45.6,5.411-44.337,6.514-62.513,10.506-94.348,2.259-18.019,5.779-43.865,11.4-75.227C873.69,628.593,873.69,628.593,889.187,627.7Z",
    transform: "translate(-818.155 -616.923)",
    fill: "#353535",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M863.656,759.6c2.784,39.347-.158,64.51-3.625,80.69-2.994,13.869-2.312,28.315-4.1,42.394-.893,6.882-2.1,15.55,2.732,23.692A28.737,28.737,0,0,0,870.958,917.3a25.162,25.162,0,0,1-14.131-1.366,24.753,24.753,0,0,1-10.927-8.668c2.522-21.853,5.148-43.759,7.722-65.613Q858.587,800.523,863.656,759.6Z",
    transform: "translate(-818.155 -679.533)",
    fill: "#353535",
    opacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_back",
    transform: "translate(146.86 106.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M993.727,389.367c-1.1.63-.63,6.777.368,18.912.1,1,.158,2.154.315,3.73.368,3.572.841,7.039,1.418,10.769a418.257,418.257,0,0,0,10.559,49.328,318.842,318.842,0,0,0,13.291,36.563,15.493,15.493,0,0,0,6.356,6.356c3.625,1.839,6.882,1.313,11.715.42a40.518,40.518,0,0,0,17.493-7.67c3.152-2.416,7.3-5.621,6.934-9.351-.158-1.313-.893-3.257-2.522-3.835a4.087,4.087,0,0,0-4.412,1.681,61.062,61.062,0,0,0,5.358-8.931c2.679-5.463,2.679-7.354,2.1-8.72a5.022,5.022,0,0,0-2.1-2.364c-.368-.158-1.1-.473-3.467,0-2.784.525-3.2,1.208-4.99,1.261-1.681.052-2.207-.525-3.467-.63-1.628-.158-4.045.473-7.3,4.255a3.419,3.419,0,0,0-2.312-.841c-1.681.053-2.994,1.629-6.356,7.46-1.051,1.786-2.364,4.15-3.835,7.039-.735-3.257-1.839-8.3-3.1-14.446-4.308-21.643-3.677-25.846-6.934-41.658-4.57-22.484-9.4-31.887-13.658-38.244C1001.081,394.042,995.67,388.211,993.727,389.367Z",
    transform: "translate(-992.686 -388.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4640",
    "data-name": "Group 4640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M993.517,390.128c2.364-1.1,5.2,3.1,6.462,4.623a60.7,60.7,0,0,1,4.36,6.041,74.073,74.073,0,0,1,6.251,12.188c3.887,9.4,6.146,19.384,7.932,29.366,1.839,10.4,3.31,20.855,4.938,31.257,1.418,9.036,2.364,18.649,7.407,26.529.525.84,1.891.053,1.366-.788-4.465-6.934-5.568-15.182-6.777-23.114-1.366-8.931-2.732-17.861-4.15-26.792-2.574-16.232-5.831-32.885-14.236-47.227a71.5,71.5,0,0,0-6.777-9.561c-1.891-2.154-4.36-5.358-7.512-3.887-1,.42-.21,1.786.735,1.366Z",
    transform: "translate(-992.318 -388.389)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4643",
    "data-name": "Group 4643",
    transform: "translate(0.878 23.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4642",
    "data-name": "Group 4642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M994,433.111a345.6,345.6,0,0,0,8.878,47.962c3.993,15.339,8.668,31.152,15.392,45.546,2.837,5.989,8.2,12.608,15.655,10.664a.79.79,0,0,0-.42-1.523c-10.454,2.784-14.972-12.188-17.7-19.279q-5.043-13.238-8.983-26.792a345.165,345.165,0,0,1-11.295-56.525c-.053-1.051-1.629-1.1-1.523-.052Z",
    transform: "translate(-993.991 -432.349)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4645",
    "data-name": "Group 4645",
    transform: "translate(35.631 90.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4644",
    "data-name": "Group 4644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M1061.592,577.126c1.366-2.784,2.679-5.621,4.045-8.405,1.418-2.889,3.152-6.934,6.987-6.567,1,.105,1-1.471,0-1.576-2.994-.263-5.148,1.681-6.619,4.045-2.259,3.625-3.887,7.827-5.778,11.662-.42.946.893,1.734,1.366.841Z",
    transform: "translate(-1060.145 -560.555)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4647",
    "data-name": "Group 4647",
    transform: "translate(43.474 87.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M1076.559,567.393c2.259-3.782,6.567-14.289,12.45-11.084.893.473,1.681-.893.788-1.366-7.2-3.94-11.872,7.039-14.6,11.61a.8.8,0,0,0,1.366.841Z",
    transform: "translate(-1075.075 -554.105)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4649",
    "data-name": "Group 4649",
    transform: "translate(48 86.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4648",
    "data-name": "Group 4648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M1085.219,569.1c1.891-2.679,3.835-5.358,5.726-8.037,2.049-2.889,4.78-6.409,8.773-5.831,1,.157,1.418-1.366.42-1.524-3.31-.525-5.989,1.051-8.143,3.467-3.047,3.362-5.516,7.46-8.143,11.137-.63.788.736,1.576,1.366.788Z",
    transform: "translate(-1083.691 -553.608)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651",
    transform: "translate(52.702 86.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M1093.933,570.41c2.259-2.679,4.465-5.411,6.724-8.09,1.313-1.576,6.566-9.718,8.773-4.886.578,1.208-.368,3.677-.788,4.886a35.916,35.916,0,0,1-2.207,4.518,63.925,63.925,0,0,1-5.936,9.351c-.63.788.473,1.891,1.1,1.1a70.038,70.038,0,0,0,7.407-11.977c1.313-2.627,3.362-7.407,1.313-10.191s-5.568-.052-7.144,1.734c-3.572,4.045-6.934,8.3-10.349,12.45-.63.735.473,1.839,1.1,1.1Z",
    transform: "translate(-1092.642 -553.932)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653",
    transform: "translate(62.872 86.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M1112.788,555.22a10.957,10.957,0,0,1,2.259.578.752.752,0,0,0,.946-.525.8.8,0,0,0-.526-.946,11.081,11.081,0,0,0-2.679-.63c-.42-.052-.788.42-.788.788a.8.8,0,0,0,.788.736Z",
    transform: "translate(-1112 -553.693)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4655",
    "data-name": "Group 4655",
    transform: "translate(39.639 104.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4654",
    "data-name": "Group 4654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M1092.479,590.108c1.208-1.523,3.572-.473,4.045,1.208a5.135,5.135,0,0,1,.052,2.364,9.72,9.72,0,0,1-2.679,4.518,32.354,32.354,0,0,1-7.46,5.884,42.056,42.056,0,0,1-17.913,5.2c-1,.053-1,1.628,0,1.576,9.456-.683,18.754-3.94,25.636-10.664,2.522-2.469,5.043-5.936,3.782-9.666-.946-2.837-4.518-4.15-6.567-1.576-.683.841.473,1.944,1.1,1.156Z",
    transform: "translate(-1067.775 -587.572)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M995.306,391.2c1.156,4.15,2.837,10.559,4.781,18.439,4.991,20.435,8.247,37.613,14.341,62.934,6.146,25.531,8.458,31.309,14.131,33.516,6.3,2.416,18.754,1.208,26.529-5.253,2.469-2.049,4.938-4.991,6.2-4.308,1.313.735.946,5.043-.736,8.353-3.152,6.3-10.559,8.458-17.7,10.506-5.831,1.681-8.773,2.522-12.45,1.418-5.411-1.628-8.51-6.146-10.034-8.353-1.891-2.784-2.206-4.413-4.78-11.5-2.627-7.3-2.837-7.092-4.78-12.45a251.825,251.825,0,0,1-7.67-25.846c-2.994-11.977-5.726-23.062-7.2-38.034A227.943,227.943,0,0,1,995.306,391.2Z",
    transform: "translate(-993.634 -389.723)",
    fill: "#353535",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M1041.5,603.563a29.263,29.263,0,0,0,19.595,8.825c12.713.473,20.8-7.827,22.011-9.088a26.038,26.038,0,0,1-8.615,8.825,27.905,27.905,0,0,1-8.142,3.362c-7.2,2.1-11.872,3.415-16.285,1.418C1043.339,613.912,1041.763,605.034,1041.5,603.563Z",
    transform: "translate(-1015.664 -490.402)",
    fill: "#353535",
    opacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "torso",
    transform: "translate(94.843 102.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M942.47,381.128c-5.621-.683-10.927,3.152-13.816,5.253-8.037,5.831-11.137,14.079-12.555,17.651-8.668,21.7-11.189,47.962-12.293,57.838A321,321,0,0,1,893.3,514.3a60.51,60.51,0,0,0,39.557,13.5,59.514,59.514,0,0,0,34.724-12.87c1.156-21.065,1.313-38.822,1.208-52.112-.263-24.27-1.1-35.407-4.78-48.225C961.172,404.714,954.816,382.6,942.47,381.128Z",
    transform: "translate(-893.3 -381.047)",
    fill: "#fd199e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M977.249,383.172c-5.253,5.148,7.3,25.216,9.351,29.891,9.456,21.538,13.816,56.367-8.773,114.678a66.618,66.618,0,0,0,10.244-2.732,70.421,70.421,0,0,0,18.124-9.351c.368-3.835.841-8.983,1.208-15.077.578-9.719.63-17.7.578-24.428-.1-20.488-.158-30.732-1.786-44.337a123.776,123.776,0,0,0-8.773-33.778c-3.625-8.458-7.354-14.341-13.291-15.707C983.4,382.122,979.3,381.176,977.249,383.172Z",
    transform: "translate(-932.544 -381.463)",
    fill: "#353535",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M1015.9,499.2c-1.051-.105-2.417,9.508-4.833,22.011a446.376,446.376,0,0,1-15.97,60.045c2.994-1.156,6.146-2.469,9.351-3.94,3.94-1.786,7.67-3.625,11.19-5.411C1017.9,511.7,1017.111,499.3,1015.9,499.2Z",
    transform: "translate(-941.622 -437.131)",
    fill: "#353535",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_front",
    transform: "translate(0 109.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M845.28,395.315a7.777,7.777,0,0,0-4.2-.42c-1.576,1.891-4.045,4.886-7.039,8.563C820.852,419.9,819.7,423.735,810.5,434.241c-8.825,10.086-14.919,14.814-19.437,17.861a69.366,69.366,0,0,1-10.034,5.673,64.3,64.3,0,0,1-20.908,5.306,24.832,24.832,0,0,1-5.936-3.94,28.776,28.776,0,0,1-5.516-7.46c-5.2-8.773-6.619-11.294-8.563-11.242-.683,0-1.786.368-3.152,2.417a27.6,27.6,0,0,1-2.416-1.944c-2.469-2.206-3.152-3.52-5.2-4.413-.893-.368-2.049-.893-3.047-.315a3.211,3.211,0,0,0-1.261,2.259,9.329,9.329,0,0,0-6.094-3.047c-.841-.052-2.049-.105-2.627.63-.893,1.051-.052,3.572,2.154,6.2-.525-.158-3.047-1-4.1.158-1.156,1.208.053,3.887.84,5.621,1.576,3.52,3.625,5.306,7.88,10.034,1.734,1.944,3.1,3.52,3.992,4.518a15.019,15.019,0,0,1-3.887-.946c-2.364-.946-3.152-2.049-4.2-1.734-1.156.368-1.786,2.311-1.576,3.835.263,1.734,1.891,2.784,2.889,3.362,6.041,3.677,13.5,5.516,15.812,6.094a104.537,104.537,0,0,0,10.769,2.364,70.675,70.675,0,0,0,13.028.42,147.795,147.795,0,0,0,30.049-4.57,96.319,96.319,0,0,0,16.6-5.568,79.152,79.152,0,0,0,29.366-21.591c6.041-7.2,8.615-13.133,13.816-24.953a23.325,23.325,0,0,0,2.1-8.248C852.109,405.559,850.586,397.416,845.28,395.315Z",
    transform: "translate(-713.296 -393.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(45.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4656",
    "data-name": "Group 4656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M885.816,393.418c-3.625-1.366-6.356,2.049-8.405,4.57-2.942,3.572-5.726,7.25-8.51,10.979-6.041,8.142-11.872,16.5-18.544,24.217-12.608,14.709-29.208,27.685-49.433,28.157a.789.789,0,0,0,0,1.576c18.281-.42,34.041-10.874,46.176-23.8a234.8,234.8,0,0,0,17.336-21.486c2.889-3.94,5.779-7.88,8.72-11.767,1.734-2.259,3.52-4.518,5.306-6.724,1.628-2,3.887-5.253,6.882-4.15,1,.263,1.366-1.261.473-1.576Z",
    transform: "translate(-800.175 -393.107)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(2.884 15.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4658",
    "data-name": "Group 4658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M853.021,422.884c-6.934,47.7-61.883,69.448-104.907,64.615a67,67,0,0,1-20.645-5.411,31.609,31.609,0,0,1-4.728-2.574,7.375,7.375,0,0,1-1.734-1.366c-1.208-.893-1.313-1.839-.42-2.889.105-1.418.788-1.839,2.1-1.313,2.574.578,4.2,2.784,6.987,2.837a.789.789,0,0,0,0-1.576c-2.837-.053-4.675-2.732-7.46-2.942a3.435,3.435,0,0,0-3.94,2.994c-.525,4.833,6.777,7.512,10.244,8.983,12.87,5.358,27.264,6.094,40.975,4.938,25.321-2.154,51.114-11.295,68.24-30.731,8.72-9.929,14.867-22.011,16.758-35.144.21-1-1.313-1.418-1.471-.42Z",
    transform: "translate(-718.249 -422.314)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661",
    transform: "translate(0 46.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M727.489,503.753c-1.261-2.311-3.257-3.782-5.1-5.568a41.112,41.112,0,0,1-6.566-9.456A13.965,13.965,0,0,1,714.619,486c-.683-1.313-.263-1.786,1.156-1.366a1.617,1.617,0,0,1,2.1.525,20.259,20.259,0,0,1,3.625,3.415,54.515,54.515,0,0,1,6.829,8.668c.525.841,1.891.053,1.366-.788-1.576-2.417-13.711-19.227-16.548-13.291-1.681,3.415,2.522,8.3,4.15,10.927a27.716,27.716,0,0,0,3.993,5.253c1.733,1.681,3.677,3.047,4.885,5.253.42.841,1.786.052,1.313-.84Z",
    transform: "translate(-712.758 -481.899)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663",
    transform: "translate(1.842 40.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M721.642,478.633c-.683-.683-5.779-6.934-2.522-7.3.735-.105,2.627,1.471,3.257,1.891a22.824,22.824,0,0,1,3.047,2.522A65.663,65.663,0,0,1,734.3,486.67c.578.841,1.944.053,1.366-.788-4.045-5.726-8.668-12.765-15.34-15.707-1.628-.736-3.835-.841-4.045,1.418-.263,2.889,2.311,6.356,4.2,8.2.788.683,1.891-.42,1.156-1.156Z",
    transform: "translate(-716.265 -469.705)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    transform: "translate(11.102 41.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M736.365,476.825a6.949,6.949,0,0,1-.788-2.206c.578-.473,1.156-1,1.734-1.471.368.21.788.368,1.156.578a18.388,18.388,0,0,1,4.045,3.52c2.416,2.732,4.518,5.779,6.724,8.668.631.788,2,0,1.366-.788-3.362-4.36-6.829-10.717-12.083-13.133-1.156-.525-2.784-.946-3.835,0-1.576,1.366-.42,3.835.21,5.306.315.893,1.839.473,1.471-.473Z",
    transform: "translate(-733.892 -471.43)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667",
    transform: "translate(23.1 45.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M758.5,484.063c-.42-1.313-.788-1.628.893-1.786,1.471-.105,1.523.21,2.417,1.156,1.1,1.261,2.1,2.574,3.1,3.887,1.681,2.311,3.257,4.728,4.991,7.092,2.679,3.625,6.2,8.72,11.032,9.4,1,.158,1.418-1.366.42-1.523-4.36-.63-7.67-5.358-10.086-8.668-2.206-2.994-4.255-6.2-6.514-9.141-1.313-1.629-3.309-4.991-5.778-4.885-2.627.105-2.469,3.1-1.891,4.885.21.946,1.734.525,1.419-.42Z",
    transform: "translate(-756.732 -479.595)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M850.769,406.784c-1.261-.368-3.31,4.991-7.25,11.925A111.925,111.925,0,0,1,823.662,444.5c-16.338,16.18-24.533,24.323-38.821,28.578-5.1,1.523-28.63,7.827-50.379-5.779a58.31,58.31,0,0,1-19.227-20.067,3.967,3.967,0,0,0-1.261,2.364c-.21,1.523.788,2.679,1.944,4.255a20.407,20.407,0,0,1,2.259,3.992,21.05,21.05,0,0,0,1.156,1.786c1.786,2.469,8.09,8.2,7.67,8.773-.158.21-1.366-.368-3.835-1.471-2.417-1.1-2.837-1.418-3.625-1.261a3.653,3.653,0,0,0-2.784,3.415c.052,1.418,1.261,2.364,2.364,3.2a8.729,8.729,0,0,0,2.784,1.471c4.623,1.576,5.779,2.627,9.824,3.835,11.82,3.52,25.163,3.835,25.163,3.835a111.5,111.5,0,0,0,37.771-5.568,93.9,93.9,0,0,0,32.2-17.7c6.409-5.463,16.18-13.974,21.328-28.157C852.135,419.234,852.555,407.257,850.769,406.784Z",
    transform: "translate(-713.322 -399.59)",
    fill: "#353535",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M740.4,524.289a130.81,130.81,0,0,0,30.311,2.994A135.1,135.1,0,0,0,833.645,510a91.517,91.517,0,0,1-33.516,17.7C772.34,535.531,748.858,527.6,740.4,524.289Z",
    transform: "translate(-725.879 -448.593)",
    fill: "#353535",
    opacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(84.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M889.855,246.473c-.053.105-1.891,3.2-5.516,9.456-4.2,7.2-5.936,10.191-7.67,14.446a70.082,70.082,0,0,0-2.469,7.144l6.934,2.837a36.474,36.474,0,0,0,3.362,11.557c1.944,3.992,4.728,9.824,11.032,12.66a18.841,18.841,0,0,0,7.67,1.629,19.445,19.445,0,0,0,9.981-2.837,30.309,30.309,0,0,0,2.154,7.3,29.648,29.648,0,0,0,3.2,5.726c4.938-1.891,9.876-3.782,14.762-5.726a31.5,31.5,0,0,1-4.255-9.613,33.633,33.633,0,0,1-.893-10.349c.368-6.356,2.154-9.666,4.1-15.655,2.994-9.351,4.78-14.814,3.94-20.645-1.1-7.565-6.777-16.285-15.5-19.437C908.189,230.4,895.213,239.276,889.855,246.473Z",
    transform: "translate(-873.507 -208.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M884.176,229.727c-3.257-1.261-3.992-7.67-3.362-11.925a18.635,18.635,0,0,1,4.833-9.824c5.2-5.726,10.717-5.673,18.7-9.088a56.267,56.267,0,0,0,17.441-11.925c-1,2.994-2,5.936-3.047,8.931a16.368,16.368,0,0,0,9.246-1.944,16.733,16.733,0,0,0,7.3-8.353c.841,1.313,4.308,7.039,2.469,13.553a15.371,15.371,0,0,1-2.154,4.465,21.886,21.886,0,0,0,9.823-5.358c3.572-3.52,4.045-6.724,5.516-6.567,2.837.263,3.887,11.82,4.465,18.176.368,4.2.946,7.144-.157,10.664-1,3.257-2.889,5.726-2.679,5.884.368.21,5.673-8.51,7.144-7.827.893.42-.683,3.782-1.261,10.139-.683,7.775.893,9.246-.525,14.762a37.322,37.322,0,0,1-3.362,8.037,35.934,35.934,0,0,1-7.3,10.139c-3.415,3.152-7.617,6.987-12.818,6.251-6.777-1-9.929-9.036-10.139-9.613.578,0,5.779-.263,8.353-4.255,3.257-5.1,0-12.66-3.73-13.921-2.732-.946-4.886,1.839-7.46.525-2.1-1.051-2.364-3.625-3.2-6.041-1.1-3.2-3.52-7.46-9.456-11.767a32.029,32.029,0,0,0-14.972,2.837C888.8,227.941,886.645,230.673,884.176,229.727Z",
    transform: "translate(-876.548 -185.6)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4669",
    "data-name": "Group 4669",
    transform: "translate(0 52.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2834",
    "data-name": "Path 2834",
    d: "M880.035,286.375a58.027,58.027,0,0,0-6.567,13.448c-.368,1.1-1,2.259-.21,3.2.578.683,2,.893,2.784,1.208,1.313.473,2.627,1,3.94,1.471.946.368,1.366-1.156.42-1.523-.893-.315-1.734-.63-2.627-1-.525-.21-2.259-.578-2.627-1-1.1-1.1.473-3.835.946-4.991a57.312,57.312,0,0,1,5.306-10.034c.578-.84-.788-1.628-1.366-.788Z",
    transform: "translate(-872.88 -286.016)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671",
    transform: "translate(6.745 70.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4670",
    "data-name": "Group 4670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2835",
    "data-name": "Path 2835",
    d: "M885.761,321.5c2.889,10.086,6.514,21.328,16.81,26.109.893.42,1.734-.946.788-1.366-9.876-4.623-13.291-15.445-16.075-25.163a.79.79,0,0,0-1.524.42Z",
    transform: "translate(-885.719 -320.514)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4673",
    "data-name": "Group 4673",
    transform: "translate(23.29 87.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2836",
    "data-name": "Path 2836",
    d: "M917.784,362.64c9.193,2.049,19.49-2.889,25.636-9.456.683-.735-.42-1.839-1.1-1.1-5.779,6.146-15.5,10.979-24.112,9.036a.79.79,0,0,0-.42,1.523Z",
    transform: "translate(-917.214 -351.838)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4675",
    "data-name": "Group 4675",
    transform: "translate(38.932 94.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4674",
    "data-name": "Group 4674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M947,366.324a25.241,25.241,0,0,0,5.2,12.45c.63.788,1.733-.315,1.1-1.1a23.663,23.663,0,0,1-4.728-11.347c-.105-1-1.681-1-1.576,0Z",
    transform: "translate(-946.991 -365.575)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4677",
    "data-name": "Group 4677",
    transform: "translate(53.956 87.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4676",
    "data-name": "Group 4676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M975.6,353.424a23.476,23.476,0,0,0,5.568,13.921c.63.788,1.786-.368,1.1-1.1a21.8,21.8,0,0,1-5.148-12.818c-.052-1-1.628-1-1.523,0Z",
    transform: "translate(-975.59 -352.675)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679",
    transform: "translate(44.711 53.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4678",
    "data-name": "Group 4678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M959.466,291.018a4.689,4.689,0,0,1,6.672-1.156,7.891,7.891,0,0,1,3.2,6.146c.263,3.73-2.154,11.294-7.407,9.036-.946-.42-1.734.946-.788,1.366,6.829,2.942,10.454-6.041,9.666-11.452-.473-3.1-2.259-6.146-5.358-7.2a6.17,6.17,0,0,0-7.3,2.469c-.631.841.735,1.628,1.313.788Z",
    transform: "translate(-957.991 -287.386)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4681",
    "data-name": "Group 4681",
    transform: "translate(39.208 88.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M948.663,363.35a32.982,32.982,0,0,0,7.932-7.092c.63-.788-.473-1.891-1.1-1.1a32.8,32.8,0,0,1-7.617,6.882c-.84.525-.053,1.891.788,1.313Z",
    transform: "translate(-947.516 -354.884)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683",
    transform: "translate(10.045 78.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M892.316,336.733a11.829,11.829,0,0,1,10.191-2.259c2.364.578,4.518,2.784,1.681,4.465-.735.42-1.628-.473-1-1.156a7.988,7.988,0,0,0,1.786-3.1c.315-.946,1.839-.63,1.524.315a9.026,9.026,0,0,1-2.154,3.782c-.315-.42-.683-.788-1-1.156,1.523-.946-1.891-1.786-2.154-1.839a9.346,9.346,0,0,0-3.2.105,10.487,10.487,0,0,0-4.78,2.206c-.841.578-1.681-.788-.893-1.366Z",
    transform: "translate(-892.001 -334.113)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4685",
    "data-name": "Group 4685",
    transform: "translate(15.944 52.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4684",
    "data-name": "Group 4684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M905.842,291.474a6.817,6.817,0,0,1-.788-5.043c-.368.158-.788.315-1.156.473,1.418,1.1,1.1,3.152.893,4.675a13.192,13.192,0,0,0,1.418-.21,4.915,4.915,0,0,1-.946-2.942.789.789,0,0,0-1.576,0,6.276,6.276,0,0,0,1.156,3.73c.368.473,1.313.525,1.418-.21.368-2.364.473-4.833-1.628-6.461a.772.772,0,0,0-1.156.473,8.15,8.15,0,0,0,.946,6.251c.578.946,1.944.158,1.418-.735Z",
    transform: "translate(-903.231 -285.359)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(14.084 44.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M901.009,273.12c2.574-3.047,6.3-.735,7.67,2.154.42.893,1.786.105,1.366-.788-1.786-3.782-6.934-6.2-10.139-2.469-.683.788.42,1.891,1.1,1.1Z",
    transform: "translate(-899.691 -270.155)",
    fill: "#161616"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M929.609,274.1c.21,1.208.473,3.1.893,5.306,1.156,6.251,2.154,9.824,2.522,11.5a26.347,26.347,0,0,1-6.934,22.747c-7.2,7.092-17.02,6.934-19.489,6.829a14.762,14.762,0,0,0,5.358,4.1c7.67,3.362,15.445-1.523,16.285-2.1-.1,3.415.63,4.57,1.366,4.938,2.259,1,7.3-3.677,9.508-8.72a19.166,19.166,0,0,0,.525-12.87c-2.942-4.045-3.1-5.463-2.679-5.936.63-.683,2.364.578,4.308-.105,2.049-.788,2.889-3.257,3.415-4.78.683-2.049,2.522-7.617-.893-10.874-2.154-2.049-5.673-2.416-8.983-1.261a3.9,3.9,0,0,1-2.259-1.156c-.893-.946-.893-2.049-1.366-3.94A19.079,19.079,0,0,0,929.609,274.1Z",
    transform: "translate(-888.886 -227.609)",
    fill: "#353535",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M962.122,332.444a42.118,42.118,0,0,1-2.522,10.874c1.839-.525,3.73-1.1,5.568-1.629,1.576,4.15,3.1,8.353,4.675,12.5,1.156-.578,2.259-1.156,3.414-1.786a65.6,65.6,0,0,1-3.677-10.769,64.55,64.55,0,0,1-1.628-9.718,22.226,22.226,0,0,1-2.889-3.415,24.991,24.991,0,0,1-3.152-6.3A48.884,48.884,0,0,1,962.122,332.444Z",
    transform: "translate(-914.044 -250.441)",
    fill: "#353535",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M993.706,216.3c-.735,0-.263,7.25-3.362,16.075-1.313,3.73-3.73,10.349-9.929,15.917a33.608,33.608,0,0,1-11.872,6.829,8.846,8.846,0,0,1,2.994,2.889c2.311,3.677.841,7.827.42,9.036-.578,1.681-1.366,3.887-3.572,5.043a6.914,6.914,0,0,1-4.886.42c.158.473,3.467,9.193,10.349,9.929,2.889.315,5.253-.946,7.039-1.891,4.675-2.417,7.039-6.041,9.929-10.507,3.835-5.936,6.514-10.139,6.882-16.075.263-4.675-1.156-5.884-.157-10.349a28.062,28.062,0,0,0,1-8.2c-.053-.841-.105-1.523-.158-2-2.154,2.469-4.308,4.991-6.461,7.46a26.781,26.781,0,0,0,2.311-6.462c.683-3.1.578-5.516.42-9.508C994.6,222.656,994.389,216.3,993.706,216.3Z",
    transform: "translate(-915.895 -200.173)",
    fill: "#353535",
    opacity: 0.13
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.90bc3d7ec8d810619ab40e68048f87e3.svg";
export { ForwardRef as ReactComponent };